import omit from 'lodash/omit';
import Layout from 'src/Components/Common/Layout';
import {IHeaderBarOwnProps} from 'src/Components/Common/HeaderBar/HeaderBar';

const withLayout = (Component: any, props?: ILayout) => () =>
	(
		<Layout {...omit(props, "addMap")}>
			<Component />
		</Layout>
	);

export interface ILayout extends IHeaderBarOwnProps {
	addMap?: boolean;
}

export default withLayout;
